"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.job = void 0;
var tslib_1 = require("tslib");
var joi_1 = tslib_1.__importDefault(require("joi"));
var types_def_1 = require("./types.def");
exports.job = joi_1.default.object({
    id: joi_1.default.string(),
    url: joi_1.default.string(),
    name: joi_1.default.string(),
    createdAt: types_def_1.dateDefault,
    updatedAt: types_def_1.dateDefault,
    schema: joi_1.default.string()
});
//# sourceMappingURL=job.def.js.map